import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

export type TabInfoProps = {
  /** Tab label, shown as the tooltip title. */
  label: string;
  /** One-line tab description, shown as the tooltip body. */
  body: string;
  'data-testid'?: string;
};

/**
 * Hover ⓘ info tooltip rendered inside a tab. The trigger is a plain
 * focusable span (not a button — there is no click behavior) so the tooltip
 * is also reachable by keyboard without button hover/ripple styling.
 */
const TabInfo = ({
  label,
  body,
  'data-testid': dataTestId = 'TabInfo',
}: TabInfoProps) => (
  <Tooltip
    title={
      <Stack spacing={0.5}>
        <Typography variant="subtitle2">{label}</Typography>
        <Typography variant="body2">{body}</Typography>
      </Stack>
    }
  >
    <Box
      component="span"
      display="inline-flex"
      alignItems="center"
      marginLeft={1}
      tabIndex={0}
      aria-label={`${label} description`}
      data-testid={`${dataTestId}.Icon`}
    >
      <InfoOutlinedIcon sx={{ fontSize: 16 }} />
    </Box>
  </Tooltip>
);

export default TabInfo;
